export const lastCheckedDateReducer = (state: number | null = null) => {
    return state;
};
